import {
  Button,
  Divider,
  Grid,
  GridColumn,
  Icon,
  Text,
  ThemeProvider
} from "@modernatx/ui-kit-react";
import React, { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { LoadingSpinner } from "@/components/LoadingSpinner/LoadingSpinner";
import DisplayPaymentInfo from "@/components/Payments/DisplayPaymentInfo";
import { usePaymentDetails } from "@/hooks/usePaymentDetails";
import { InvoiceFields } from "@/types/Invoice";

const PaymentConfirmationPage: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const paymentId = params.get("paymentId") ?? undefined;

  const { paymentInfo, isLoading, error } = usePaymentDetails({
    paymentId: paymentId
  });

  const handleAnotherPayment = () => {
    history.push(`/pay`);
  };

  const handleViewInvoice = () => {
    history.push(`/your-account/invoices-and-payments`);
  };

  return (
    <ThemeProvider>
      {error && <Text>{error}</Text>}
      {isLoading ? (
        <LoadingSpinner size="xl" />
      ) : (
        <Grid>
          <GridColumn size={12}>
            <GridColumn
              size={[3, 3, 3]}
              sx={{
                mt: "spacing-12",
                mb: "spacing-12",
                alignItems: "center",
                alignSelf: "center"
              }}
            >
              <Grid>
                <GridColumn
                  sx={{
                    minWidth: 365,
                    alignItems: "center",
                    textAlign: "center",
                    mb: "spacing-9"
                  }}
                >
                  <Icon
                    icon="check-circle"
                    color="color-system-green-600"
                    size="lg"
                    sx={{ mb: "spacing-6" }}
                  />
                  <Text variant="h4" sx={{ mb: "spacing-6" }}>
                    Thank you for your payment!
                  </Text>
                  {/* <Text variant="body-1-regular">
                    A confirmation email has been sent to you.
                  </Text> */}
                </GridColumn>

                <GridColumn>
                  <DisplayPaymentInfo
                    fieldName={InvoiceFields.ConfirmationNum}
                    fieldValue={paymentInfo?.confirmationNum}
                  />
                  <DisplayPaymentInfo
                    fieldName={InvoiceFields.InvoiceNums}
                    fieldValue={paymentInfo?.invoiceNums}
                  />
                  <DisplayPaymentInfo
                    fieldName={InvoiceFields.PaymentDate}
                    fieldValue={paymentInfo?.paymentDate}
                  />
                  <DisplayPaymentInfo
                    fieldName={InvoiceFields.PaymentMethod}
                    fieldValue={paymentInfo?.paymentMethod}
                  />
                  <Divider sx={{ mb: "spacing-2", mt: "spacing-4" }} />
                  <DisplayPaymentInfo
                    fieldName={InvoiceFields.Amount}
                    fieldValue={paymentInfo?.amount}
                  />
                </GridColumn>

                <GridColumn sx={{ mt: "spacing-9" }}>
                  <Button onClick={handleAnotherPayment}>
                    Make another payment
                  </Button>
                  <Button
                    sx={{ mt: "spacing-3" }}
                    variant="outline"
                    onClick={handleViewInvoice}
                  >
                    View invoice
                  </Button>
                </GridColumn>
              </Grid>
            </GridColumn>
          </GridColumn>
        </Grid>
      )}
    </ThemeProvider>
  );
};

export default PaymentConfirmationPage;
